/**
 * Created by chachora on 1/21/19.
 */
import React, { Component } from 'react';
import {
  Icon,
  ListItem,
  List,
  Divider,
  ListSubheader,
  Button,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import ContactsListDialog from '../Contacts/ContactsListDialog';
import ContactsList from '../Contacts/ContactsList';

class EventContacts extends Component {
  state = {
    isContactsListOpen: false,
    contactType: '',
  };

  toggleContactsListDialog = () => {
    this.setState(state => ({ isContactsListOpen: !state.isContactsListOpen }));
  };

  handleInboundAddContactClick = () => {
    this.setState({
      contactType: 'inbound',
    });
    this.toggleContactsListDialog();
  };

  handleOutboundAddContactClick = () => {
    this.setState({
      contactType: 'outbound',
    });
    this.toggleContactsListDialog();
  };

  handleAddContactCancel = () => {
    this.toggleContactsListDialog();
  };

  handleAddContactConfirm = contact => {
    const { contactType } = this.state;
    this.addContact(contact, contactType);
    this.toggleContactsListDialog();
  };

  handleInboundContactDelete = contact => {
    this.deleteContact(contact, 'inbound');
  };

  handleOutboundContactDelete = contact => {
    this.deleteContact(contact, 'outbound');
  };

  /**
   * Add contact to event object depending on its type (inbound or outbound)
   * @param contact
   * @param contactType
   */
  addContact = (contact, contactType) => {
    const { setFieldValue, values } = this.props;

    // check if contact already added
    if (values[contactType].contacts.find(c => c._id === contact._id)) return;

    setFieldValue(
      `${contactType}.contacts[${values[contactType].contacts.length}]`,
      contact
    );
  };

  /**
   * Delete contact to event object depending on its type (inbound or outbound)
   * @param contact
   * @param contactType
   */
  deleteContact = (contact, contactType) => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      `${contactType}.contacts`,
      values[contactType].contacts.filter(c => c._id !== contact._id)
    );
  };

  render() {
    const { isContactsListOpen } = this.state;
    const { values } = this.props;
    return (
      <>
        <List disablePadding>
          <ListSubheader disableSticky>INBOUND CONTACTS</ListSubheader>
          <ListItem>
            <Button
              color="primary"
              fullWidth
              variant="contained"
              startIcon={<Icon>add</Icon>}
              onClick={this.handleInboundAddContactClick}
            >
              Add Contact
            </Button>
          </ListItem>
        </List>
        <ContactsList
          contacts={values.inbound.contacts}
          onContactDelete={this.handleInboundContactDelete}
        />
        <Divider />
        <List disablePadding>
          <ListSubheader disableSticky>OUTBOUND CONTACTS</ListSubheader>
          <ListItem>
            <Button
              color="primary"
              fullWidth
              variant="contained"
              startIcon={<Icon>add</Icon>}
              onClick={this.handleOutboundAddContactClick}
            >
              Add Contact
            </Button>
          </ListItem>
        </List>
        <ContactsList
          contacts={values.outbound.contacts}
          onContactDelete={this.handleOutboundContactDelete}
        />
        {isContactsListOpen && (
          <ContactsListDialog
            open={isContactsListOpen}
            onCancel={this.handleAddContactCancel}
            onConfirm={this.handleAddContactConfirm}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  textColor: {
    color: 'green',
  },
});

export default withStyles(styles)(EventContacts);
